import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { Component, inject, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogComponent } from '@app/shared';
import { TranslatePipe } from '@ngx-translate/core';
import { MassNotificationTemplateGroup } from '../../store/communications';
import { TemplateGroupCRUDInputComponent } from './template-group-crud-input/template-group-crud-input.component';
import { TemplateGroupCRUDItemComponent } from './template-group-crud-item/template-group-crud-item.component';
import { TemplateGroupDeleteDialogComponent } from './template-group-delete-dialog/template-group-delete-dialog.component';
import { TemplateGroupInputDialogComponent } from './template-group-input-dialog/template-group-input-dialog.component';
import { TemplateGroupsCRUDModalStore } from './template-groups-crud-modal.store';

@Component({
  selector: 'topo-template-groups-crud-modal',
  imports: [ReactiveFormsModule, DialogComponent, TranslatePipe, TemplateGroupCRUDInputComponent, TemplateGroupCRUDItemComponent],
  providers: [TemplateGroupsCRUDModalStore],
  templateUrl: './template-groups-crud-modal.component.html',
  styleUrl: './template-groups-crud-modal.component.scss'
})
export class TemplateGroupsCRUDModalComponent {
  protected state = inject(TemplateGroupsCRUDModalStore);
  protected dialogRef = inject<DialogRef>(DialogRef);
  private dialog = inject(Dialog);

  protected searchTerm = signal<string>('');

  onSubmit(value: string): void {
    this.dialogRef.close();
  }

  // filteredTemplateGroups = computed(() => {
  //   const templateGroups = this.state.templateGroups();
  //   const searchTerm = this.searchTerm()?.trim();

  //   if (!Boolean(searchTerm)) {
  //     return templateGroups;
  //   }

  //   return templateGroups.filter(t => t.name.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()));
  // });

  createTemplateGroup(name: string) {
    this.state.createTemplateGroup(name);
  }

  editTemplateGroup(templateGroup: MassNotificationTemplateGroup): void {
    const dialogRef = this.dialog.open(TemplateGroupInputDialogComponent, {
      autoFocus: false,
      width: '100%',
      maxWidth: '500px',
      disableClose: true,
      data: {
        state: this.state,
        templateGroup
      }
    });

    dialogRef.closed.subscribe((value: string) => {
      if (!!value) {
        this.state.updateTemplateGroup({ ...templateGroup, name: value.trim() });
      }
    });
  }

  deleteTemplateGroup(templateGroup: MassNotificationTemplateGroup): void {
    const dialogRef = this.dialog.open(TemplateGroupDeleteDialogComponent, {
      autoFocus: false,
      width: '100%',
      maxWidth: '580px',
      disableClose: true,
      data: {
        templateGroup
      }
    });

    dialogRef.closed.subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.state.deleteTemplateGroup(templateGroup);
      }
    });
  }
}
